import React, { createContext, useCallback, useContext, useState } from 'react';

import logger from '../utils/logger';

export const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: 'success',
    message: '',
    autoHideDuration: 6000,
  });

  const openSnackbar = useCallback((severity, message, options = {}) => {
    setSnackbarState({
      open: true,
      severity,
      message,
      autoHideDuration: options.autoHideDuration !== undefined ? options.autoHideDuration : 6000,
    });
  }, []);

  const closeSnackbar = () => {
    logger.debug('Closing Snackbar');
    setSnackbarState((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  return (
    <SnackbarContext.Provider value={{ snackbarState, openSnackbar, closeSnackbar }}>
      {children}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  return useContext(SnackbarContext);
};
